import React, { memo, useEffect, useMemo } from 'react'
import styled from 'styled-components'

import { useAppDispatch, useAppSelector } from 'state/hooks'
import {
  selectCurrentMarketInfo,
  selectDesireMode,
  selectOrderDirection,
  selectOrderErrorMessage,
  selectOrderPrice,
  selectOrderSize,
  selectOrderTotal,
  selectOrderType,
  selectSlippage
} from 'state/exchange/selectors'
import { selectBalanceInBank } from 'state/wallet/selectors'
import { OrderDirection } from '@bitly/sdk/types'
import { fetchTargetSwapAmount } from 'state/exchange/actions'

type OrderInputErrorsProps = {
	isMobile?: boolean
}

const OrderInputErrors: React.FC<OrderInputErrorsProps> = memo(({ isMobile }) => {
	const dispatch = useAppDispatch()
	const marketInfo = useAppSelector(selectCurrentMarketInfo)
	const orderPrice = Number(useAppSelector(selectOrderPrice))
	const slippage = useAppSelector(selectSlippage)
	const orderDirection = useAppSelector(selectOrderDirection)
	const orderType = useAppSelector(selectOrderType)
	const orderSize = useAppSelector(selectOrderSize)
	const orderTotal = useAppSelector(selectOrderTotal)
	const desireMode = useAppSelector(selectDesireMode)
	const balances = useAppSelector(selectBalanceInBank)
	const errorMessage = useAppSelector(selectOrderErrorMessage)

	useEffect(() => {
		dispatch(fetchTargetSwapAmount())
	}, [dispatch, marketInfo, orderSize, orderTotal, desireMode, slippage, orderDirection, balances, orderType, orderPrice])

	if (!errorMessage) {
		return <></>
	}

	return <ErrorText>{errorMessage}</ErrorText>
})

const ErrorText = styled.div`
	color: ${(props) => props.theme.colors.selectedTheme.red};
	font-size: 14px;
	margin-bottom: 8px;
`

export default OrderInputErrors
